import { Copy, Check, Terminal } from 'lucide-react'
import { getPullCommand } from '@/lib/utils'
import { useCopyToClipboard } from '@/hooks/useCopyToClipboard'

interface PullCommandProps {
  imageName: string
  tag?: string
}

export default function PullCommand({ imageName, tag = 'latest' }: PullCommandProps) {
  const command = getPullCommand(imageName, tag)
  const { copied, copy } = useCopyToClipboard()

  return (
    <div className="terminal group relative">
      <div className="flex items-center gap-2 text-dark-500 mb-2">
        <Terminal className="h-4 w-4" />
        <span className="text-xs">Pull Command</span>
      </div>

      <div className="flex items-center justify-between gap-4">
        <code className="text-accent-400 break-all">
          <span className="text-dark-500 select-none">$ </span>
          {command}
        </code>

        <button
          onClick={() => copy(command)}
          className="flex-shrink-0 p-2 rounded-lg bg-dark-800 hover:bg-dark-700 text-dark-400 hover:text-white transition-colors"
          aria-label={copied ? 'Copied!' : 'Copy to clipboard'}
        >
          {copied ? (
            <Check className="h-4 w-4 text-accent-500" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
        </button>
      </div>
    </div>
  )
}
